import React, { useState } from 'react';
import { Placement } from 'react-joyride';
import Tour from 'components/Tour';
import { useOnboardingContext } from 'store/OnboardingContext';
import useAddCompletedOnboardingItems from 'hooks/api/Onboarding/useAddCompletedOnboardingItems';
import { useWorkspaceContext } from 'store/WorkspaceContext';
import { OnboardingItem } from 'api-client';

const steps = [
  {
    target: '[basic-tour-step="0"]',
    title: 'Manage all your assets',
    content:
      'Store, catalog, and govern all your data and code in a single data platform. TileDB has all the functionality you need to build a single infrastructure for your organization.',
    placement: 'right' as Placement,
  },
  {
    target: '[basic-tour-step="1"]',
    title: 'Launch apps',
    content:
      'Keep track of your active notebooks and dashboards and continue your work from where you left off.',
    placement: 'right' as Placement,
  },
  {
    target: '[basic-tour-step="2"]',
    title: 'Monitor your servers',
    content:
      'Launch, manage, and monitor your notebook servers. Track serverless compute activity.',
    placement: 'right' as Placement,
  },
  {
    target: '[basic-tour-step="3"]',
    title: 'Learn on Academy',
    content:
      'Read documentation and track your progress with tutorials on the areas of your interest.',
    placement: 'right' as Placement,
  },
  {
    target: '[basic-tour-step="4"]',
    title: 'Explore public assets',
    content:
      'Discover and access a selection of public assets in our marketplace. Browse, select, and utilize resources that can propel your projects forward.',
    placement: 'right' as Placement,
  },
  {
    target: '[basic-tour-step="5"]',
    title: 'Switch namespace',
    content:
      'Effortlessly toggle between your own namespace and the different organizations you belong to.',
    placement: 'right' as Placement,
  },
  {
    target: '[basic-tour-step="6"]',
    title: 'Unlock your full potential',
    content:
      'Complete your onboarding journey and discover the extensive capabilities that TileDB Cloud offers to enhance your data management and analysis needs.',
    placement: 'right' as Placement,
  },
];

const BasicTour = () => {
  const { workspace } = useWorkspaceContext();
  const { refetchCompletedOnboardingItems } = useOnboardingContext();
  const [addOnboardingItems] = useAddCompletedOnboardingItems();
  const [active, setActive] = useState(true);
  const addOnboardingItemsData = {
    namespace: workspace?.namespace as string,
    items: {
      entries: [OnboardingItem.BasicTour],
    },
  };

  const onFinish = async () => {
    await addOnboardingItems([addOnboardingItemsData]);
    refetchCompletedOnboardingItems();
  };

  const onDismiss = async () => {
    setActive(false);
    await addOnboardingItems([addOnboardingItemsData]);
    refetchCompletedOnboardingItems();
  };

  return (
    <Tour
      steps={steps}
      active={active}
      onFinish={onFinish}
      onDismiss={onDismiss}
      startWithDelay={1000}
      dismissable
    />
  );
};

export default BasicTour;
